var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "schoolWarp" },
    [
      _c("ZhjySerach", {
        attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
        on: {
          "update:modelData": function ($event) {
            _vm.modelData = $event
          },
          "update:model-data": function ($event) {
            _vm.modelData = $event
          },
          search: _vm.search,
        },
      }),
      _vm._v(" "),
      _c("FunBtn", {
        attrs: {
          funBtns: _vm.funBtns,
          defaultColumn: _vm.defaultColumn,
          isShowSelectChange: true,
        },
        on: { add: _vm.add, delMore: _vm.delMore },
      }),
      _vm._v(" "),
      _c("ZhjyTable", {
        attrs: {
          minWidth: _vm.minWidth,
          tableData: _vm.listData,
          columList: _vm.defaultColumn,
          isShowSelection: true,
          options: _vm.options,
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          formatters: _vm.formatters,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          delMore: _vm.delMore,
          handleSelectionChange: _vm.handleSelectionChange,
        },
      }),
      _vm._v(" "),
      _c("ZhjyPagination", {
        attrs: {
          pageNum: _vm.page.pageNumber,
          pageSize: _vm.page.pageSize,
          total: _vm.totalData,
        },
        on: {
          "update:pageNum": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          "update:page-num": function ($event) {
            return _vm.$set(_vm.page, "pageNumber", $event)
          },
          handleCurrentChange: _vm.handleCurrentChange,
          handleSizeChange: _vm.handleSizeChange,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "sdfpDia pubDia",
          attrs: { title: "参赛选手分配", visible: _vm.allotDia, width: "50%" },
          on: {
            "update:visible": function ($event) {
              _vm.allotDia = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c("ZhjySerach", {
                attrs: {
                  queryGroup: _vm.queryGroup2,
                  modelData: _vm.modelDate2,
                },
                on: {
                  "update:modelData": function ($event) {
                    _vm.modelDate2 = $event
                  },
                  "update:model-data": function ($event) {
                    _vm.modelDate2 = $event
                  },
                  search: _vm.search2,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("ZhjyTable", {
            attrs: {
              tableData: _vm.tableData2,
              columList: _vm.defaultColumn2,
              isShowSelection: true,
              pageNum: _vm.page2.pageNumber,
              pageSize: _vm.page2.pageSize,
            },
            on: {
              "update:pageNum": function ($event) {
                return _vm.$set(_vm.page2, "pageNumber", $event)
              },
              "update:page-num": function ($event) {
                return _vm.$set(_vm.page2, "pageNumber", $event)
              },
              handleSelectionChange: _vm.handleSelectionChange2,
            },
          }),
          _vm._v(" "),
          _c("ZhjyPagination", {
            attrs: {
              pageNum: _vm.page2.pageNumber,
              pageSize: _vm.page2.pageSize,
              total: _vm.total2,
            },
            on: {
              "update:pageNum": function ($event) {
                return _vm.$set(_vm.page2, "pageNumber", $event)
              },
              "update:page-num": function ($event) {
                return _vm.$set(_vm.page2, "pageNumber", $event)
              },
              handleCurrentChange: _vm.handleCurrentChange2,
              handleSizeChange: _vm.handleSizeChange2,
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.isAllot } },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.optAllot } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }